const Menu = [
  
  { header: 'Сервисы' },
  {
    title: 'Персонал',
    group: 'staffs',
    component: 'staffs',
    icon: 'account_circle',
    items: [
      { name: 'staffList', title: 'Ставки', component: 'staffs/list' }, 
      { name: 'accounts', title: 'Аккаунты', component: 'staffs/accounts' }, 
      { name: 'staffPosition', title: 'Должности', component: 'staffs/position' }, 
      { name: 'kpi', title: 'KPI', component: 'staffs/kpi' },
      { name: 'accountAppVersion', title: 'Версии POH', component: 'staffs/account-app-version' },
    ]
  },
  {
    title: 'Территории',
    group: 'territories',
    icon: 'location_city',
    items: [ 
      { name: 'countries', title: 'Страны', component: 'territories/countries' },
      { name: 'regions', title: 'Регионы', component: 'territories/regions' },
      { name: 'cities', title: 'Города', component: 'territories/cities' },
    ]
  },

  {
    title: 'Email',
    group: 'email',
    component: 'email',
    icon: 'email',
    items: [ 
      { name: 'emailTemplate', title: 'Шаблоны писем', component: 'email/template' },
      { name: 'emailSignatureTemplate', title: 'Шаблоны подписей для писем', component: 'email/signatureTemplate' },
    ]
  }, 
  {
    title: 'Стоматолог',
    group: 'shopEmployee',
    component: 'shopEmployee',
    icon: 'account_box',
    items: [
      { name: 'shopEmployeePosition', title: 'Должности', component: 'shopEmployee/position' },
      { name: 'specialization', title: 'Специализации', component: 'shopEmployee/specialization' },
      { name: 'deactivationReason', title: 'Причины деактивации', component: 'shopEmployee/deactivationReason' },
      { name: 'exhibition', title: 'Мероприятия', component: 'shopEmployee/exhibition' },
    ]
  },
  {
    title: 'Клиника',
    group: 'shop',
    component: 'shop',
    icon: 'local_hospital',
    items: [
      { name: 'propertyType', title: 'Вид собственности', component: 'shop/propertyType' },
      { name: 'competitor', title: 'Конкуренты', component: 'shop/competitor' },
      { name: 'dobd', title: 'DOBD рейтинг', component: 'shop/dobd' },
    ]
  },
  {
    title: 'Права доступа',
    group: 'permission',
    component: 'permission',
    icon: 'lock',
    items: [  
    { name: 'roles', title: 'Роли', component: 'permission/roles' },
    { name: 'levels', title: 'Уровни', component: 'permission/levels' },
    { name: 'objects', title: 'Обьекты', component: 'permission/objects' },
    ]
  }, 
  {
    title: 'Клиенты',
    group: 'clients',
    component: 'clients',
    icon: 'fa-address-book',
    items: [
      { name: 'employees', title: 'Стоматологи', component: 'clients/employees' },
      { name: 'appVersions', title: 'Версии Приложения', component: 'clients/appVersions' },
      { name: 'clinics', title: 'Клиники', component: 'clients/clinics' },
    ]
  },
  {
    title: 'Визиты',
    group: 'visits',
    component: 'visits',
    icon: 'fa-black-tie',
    items: [
      { name: 'visitList', title: 'Визиты', component: 'visits/list' },
      { name: 'pollQuests', title: 'Вопросы', component: 'visits/pollQuests' },
      { name: 'pollTemplates', title: 'Анкеты', component: 'visits/pollTemplates' },
      { name: 'programs', title: 'Программы', component: 'visits/programs' },
      { name: 'property', title: 'Свойства', component: 'visits/property' },
      { name: 'dataType', title: 'Типы данных', component: 'visits/dataType' },
    ]
  },
  {
    title: 'POSM',
    name: 'posm/list',
    group: 'posm',
    component: 'POSMList',
    icon: 'fa-archive'
  },
  {
    title: 'Шаблоны SMS',
    name: 'templatesSms/list',
    group: 'templates',
    component: 'TemplatesSms',
    icon: 'fa-comment'
  },
  {
    title: 'Настройки',
    name: 'appsettings/list',
    group: 'appsettings',
    component: 'AppSettings',
    icon: 'fa-cog'
  },
  {
    title: 'Dashboard',
    group: 'dashboard',
    component: 'dashboard',
    icon: 'fa-table',
    items: [
      { name: 'dashboardIndexList', title: 'Показатели', component: 'dashboard/indexList' },
    ]
  },
  {
    title: 'Импорт данных',
    group: 'import',
    component: 'import',
    icon: 'file_upload',
    items: [
      { name: 'geo', title: 'Гео', component: 'import/geo' },
      // { name: 'clinics', title: 'Клиники', component: 'import/clinics' },
      // { name: 'shopEmployees', title: 'Стоматологи', component: 'import/shopEmployees' },
      // { name: 'accounts', title: 'Аккаунты', component: 'import/accounts' },
      // { name: 'posm', title: 'POSM', component: 'import/posm' },
    ]
  },
  { header: 'Прочее' },
  {
    title: 'Разработчикам',
    group: 'dev',
    component: 'dev',
    icon: 'code',
    items: [
      { name: 'logs', title: 'Логи', component: 'dev/log' },
      { name: 'logError', title: 'Отчет по логам', component: 'dev/logError'  }
    ]
  },
  {
    title: 'Отчеты',
    group: 'reports',
    icon: 'format_list_numbered',
    name: 'reports',
  },
  {
    title: 'Alidi',
    group: 'alidi',
    icon: 'next_week',
    name: 'alidi',
  },
 
];

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase(),
          textB = y.title.toUpperCase();

      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;


// WEBPACK FOOTER //
// ./src/api/menu.js